@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container spread-container" [ngClass]="tupleClass" [style.--option-group-rows]="rows">
    <div class="option-group-header">
        <span>{{ firstParticipant }}</span>
        @if (numberOfOptions > 2) {
            <span>{{ sitecore.event.Tie }}</span>
        }
        <span>{{ secondParticipant }}</span>
    </div>
    <ng-container *rxFor="let group of optionGroups | slice: 0 : visibleOptionsLimit; trackBy: trackGroup">
        <ms-option
            *ngFor="let option of group.options; trackBy: trackOption"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [option]="option"
            [optionGroup]="optionGroup"
            [event]="event"
            [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails"></ms-option>
    </ng-container>
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
